import React, { useState, useEffect } from 'react';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { useLanguage } from '../../../../contexts/LanguageContext';

const DealerStockAddFilters = ({ filters, onApplyFilters, onReset }) => {
    const { th } = useLanguage();
    const [filterOpen, setFilterOpen] = useState(true);

    const [localFilters, setLocalFilters] = useState({
        startDate: filters.startDate,
        endDate: filters.endDate
    });

    useEffect(() => {
        setLocalFilters({
            startDate: filters.startDate,
            endDate: filters.endDate
        });
    }, [filters.startDate, filters.endDate]);

    const toggleOpen = () => setFilterOpen((prev) => !prev);

    const handleStartDateChange = (e) => {
        setLocalFilters((prev) => ({ ...prev, startDate: e.value }));
    };

    const handleEndDateChange = (e) => {
        setLocalFilters((prev) => ({ ...prev, endDate: e.value }));
    };

    const handleApply = () => {
        onApplyFilters(localFilters);
    };

    const handleReset = () => {
        onReset();
    };

    return (
        <div className="generic-table-filter">
            <div className="grid">
                <div className="col-12 md:col-6 flex justify-content-start">
                    <Button
                        icon="pi pi-filter"
                        label={th('common.filter')}
                        onClick={toggleOpen}
                        outlined={!filterOpen}
                    />
                </div>
            </div>

            {filterOpen && (
                <div className="mt-3">
                    <Divider />
                    <div className="text-xl font-medium mb-3">{th('filter.advancedFilters')}</div>

                    <div className="flex flex-wrap gap-2" style={{ alignItems: 'end' }}>
                        <div className="flex-auto" style={{ minWidth: 200, maxWidth: 280 }}>
                            <div className="field mb-2 p-1">
                                <label className="block mb-1 text-sm">{th('dealerStockAdd.filters.startDate')}</label>
                                <Calendar
                                    id="startDate"
                                    value={localFilters.startDate}
                                    onChange={handleStartDateChange}
                                    dateFormat="dd/mm/yy"
                                    showIcon
                                    className="w-full"
                                    maxDate={localFilters.endDate}
                                    placeholder={th('common.selectDate')}
                                />
                            </div>
                        </div>

                        <div className="flex-auto" style={{ minWidth: 200, maxWidth: 280 }}>
                            <div className="field mb-2 p-1">
                                <label className="block mb-1 text-sm">{th('dealerStockAdd.filters.endDate')}</label>
                                <Calendar
                                    id="endDate"
                                    value={localFilters.endDate}
                                    onChange={handleEndDateChange}
                                    dateFormat="dd/mm/yy"
                                    showIcon
                                    className="w-full"
                                    minDate={localFilters.startDate}
                                    placeholder={th('common.selectDate')}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-content-start mt-3">
                        <Button
                            label={th('filter.reset')}
                            icon="pi pi-refresh"
                            className="p-button-outlined mr-2"
                            onClick={handleReset}
                        />
                        <Button
                            label={th('filter.apply')}
                            icon="pi pi-check"
                            onClick={handleApply}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default DealerStockAddFilters;
